import $ from 'jquery';
import moment from 'moment';
import {
  DARK_THEME,
  DRAWER_TYPE,
  FIXED_DRAWER,
  SWITCH_LANGUAGE_SUCCESS,
  THEME_COLOR,
  TOGGLE_COLLAPSED_NAV,
  WINDOW_WIDTH,
} from '../constants/ActionTypes';
import { CYAN } from '../constants/ThemeColors';
import { LOCALES, LOCALE } from '../constants/Values';
import { addCookie, getCookie } from '../util/cookies';
import { getUserLocale } from '../util/userLocale';

const applyAndReturnDefaultLocale = () => {
  const defaultLocale = LOCALES.find(locale => locale.locale === getUserLocale());
  addCookie(LOCALE, defaultLocale.locale, true);

  return defaultLocale;
};

const getLocaleInfo = () => {
  const appLocale = getCookie(LOCALE);

  if (!appLocale) {
    return applyAndReturnDefaultLocale();
  }

  const supportedLocale = LOCALES.find(locale => locale.locale === appLocale);

  if (!supportedLocale) {
    return applyAndReturnDefaultLocale();
  }
  addCookie(LOCALE, supportedLocale.locale, true);
  moment.locale(supportedLocale.locale);

  return supportedLocale;
};

const initialSettings = {
  navCollapsed: false,
  drawerType: [FIXED_DRAWER],
  themeColor: CYAN,
  sideNavColor: CYAN,
  darkTheme: false,
  width: $(window).width(),
  isDirectionRTL: false,
  locale: getLocaleInfo(),
};

const settings = (state = initialSettings, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        navCollapsed: false,
      };
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.isNavCollapsed,
      };
    case DRAWER_TYPE:
      return {
        ...state,
        drawerType: [action.drawerType],
      };
    case WINDOW_WIDTH:
      return {
        ...state,
        width: action.width,
      };
    case THEME_COLOR:
      return {
        ...state,
        darkTheme: false,
        themeColor: action.color,
      };
    case DARK_THEME:
      return {
        ...state,
        darkTheme: !state.darkTheme,
      };
    case SWITCH_LANGUAGE_SUCCESS:
      return {
        ...state,
        locale: action.payload,
        // isDirectionRTL: rltLocale.includes(action.payload.locale)
      };
    default:
      return state;
  }
};

export default settings;
